import React from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
} from './style';

import AppState from '../../states/AppState';

const Tooltip = ({ text }) => text && AppState.viewportX !== null && AppState.viewportY !== null && (
  <Wrapper
    style={{
      left: AppState.viewportX,
      top: AppState.viewportY,
    }}
  >
    {text}
  </Wrapper>
);

export default observer(Tooltip);



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js